<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageTaxes.title') }}
    </portal>

    <template v-if="taxes !== null">
      <card :title="$t('admin.pageTaxes.card.taxes')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <template v-for="tax in taxes" v-if="!tax.deleted">
              <hm-card-inner-line :title="getName(tax)" :clickable="true" :key="tax.id" @click="routeToTax(tax)" />
            </template>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedTaxes)" :title="$t('admin.pageTaxes.card.deletedTaxes')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="tax in deletedTaxes"
                              :title="getName(tax)"
                              :clickable="true"
                              :key="tax.id"
                              @click="routeToTax(tax)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageTaxes.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageTaxes.actions.addTax')" icon="plus" color="blue" @click="addTax()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, flattenDeep, groupBy, isEmpty, isNil, keyBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageTaxes',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      taxes: null,
    };
  },

  computed: {
    deletedTaxes: function () {
      return isNil(this.taxes) ? null : this.taxes.filter(it => it.deleted === true);
    },
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.tax.list(this))
        .then((response) => {
          this.taxes = sortBy(response.data.data, ['sort', 'taxType', `name.${this.hotelSettings.details.primaryLanguage}`]);

          this.$serviceBus.$emit('tax.list', this.taxes);
        });
    },
    addTax() {
      this.axios.post(this.serviceUrls.tax.list(this), {
        name: {
          [this.hotelSettings.details.primaryLanguage]: this.$t('admin.pageTaxes.newTaxName'),
        },
        description: {
          [this.hotelSettings.details.primaryLanguage]: '',
        },
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(tax) {
      const name = isNil(tax) ? null : tax.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      let details = '';

      if (tax.deleted === false) {
        if (!isNil(tax.amount) && tax.amount !== 0) {
          details += `, ${tax.amount.toLocaleString(this.$i18n.locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${tax.percentage === true ? '%' : this.hotelSettings.details.currency}`;
        }

        if (tax.taxType === 'VAT') {
          if (this.hotelSettings.details.vatIncluded !== false) {
            details += ` (${tax.vatLabel})`;
          }
        } else if (!tax.percentage) {
          if (tax.rateMode === 'PerPerson') {
            details += ` ${this.$t('RateMode.PerPerson')}`;
          }

          if (tax.rateFrequency === 'PerNight') {
            details += ` ${this.$t('RateFrequency.PerNight')}`;
          }
        }

        if (!isNil(tax.seasonalValidFrom) && !isNil(tax.seasonalValidUntil)) {
          details += `, ${this.$t('admin.pageTaxes.description.seasonalValiditiy')} ${this.$moment(`${tax.seasonalValidFrom[0]}-${tax.seasonalValidFrom[1]}`, 'DD-MM').format(this.dayMonthFormat)} - ${this.$moment(`${tax.seasonalValidUntil[0]}-${tax.seasonalValidUntil[1]}`, 'DD-MM').format(this.dayMonthFormat)}`;
        }

        if (!isNil(tax.validFrom) && !isNil(tax.validUntil)) {
          details += `, ${this.$moment(tax.validFrom, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'))} - ${this.$moment(tax.validUntil, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'))}`;
        } else if (!isNil(tax.validFrom) && isNil(tax.validUntil)) {
          details += `, ${this.$t('admin.pageTaxes.description.validFrom')} ${this.$moment(tax.validFrom, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'))}`;
        } else if (isNil(tax.validFrom) && !isNil(tax.validUntil)) {
          details += `, ${this.$t('admin.pageTaxes.description.validUntil')} ${this.$moment(tax.validUntil, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'))}`;
        }
      }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeToTax(tax) {
      this.$router.push({
        name: 'tax',
        params: {
          taxId: tax.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageTaxes.vue